import getZones from '../zones/utils/getZones';
/** Filter an array x/y based on various criteria x points are expected to be sorted
 *
 * @param data - points
 * @param options - options
 * @return filtered array
 */
export function xyFilterX(data, options = {}) {
    const { x, y } = data;
    const { from = x[0], to = x[x.length - 1], exclusions = [] } = options;
    let zones = getZones(from, to, exclusions);
    let currentZoneIndex = 0;
    let newX = [];
    let newY = [];
    let position = 0;
    while (position < x.length) {
        if (x[position] <= zones[currentZoneIndex].to &&
            x[position] >= zones[currentZoneIndex].from) {
            newX.push(x[position]);
            newY.push(y[position]);
        }
        else {
            if (x[position] > zones[currentZoneIndex].to) {
                currentZoneIndex++;
                if (!zones[currentZoneIndex])
                    break;
            }
        }
        position++;
    }
    return {
        x: newX,
        y: newY,
    };
}
//# sourceMappingURL=xyFilterX.js.map